import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { dotPath, isNilOrEmpty } from 'ramdasauce'

import { useStyles } from './styles'
import { Text, Animated } from 'components/atoms'

export const NarrowHeroImage = ({ data }) => {
  const classes = useStyles()

  const title = dotPath('title', data)
  const image = dotPath('backgroundImage.asset', data)

  return (
    <div className={classes.wrapper}>
      {!isNilOrEmpty(image) && (
        <GatsbyImage
          className={classes.image}
          image={getImage(image)}
          alt={title}
        />
      )}
      {!isNilOrEmpty(title) && (
        <Animated type="fade-in">
          <div className={classes.title}>
            <Text size="header1">{title}</Text>
          </div>
        </Animated>
      )}
    </div>
  )
}
